// The 74 works of the Polsterei gallery, from the design (const DATA in design/Arbeiten.dc.html; texts from
// ideensprung.de). Photos are design image ids, resolved by d() from lib/site.ts.

export type Category = "sofas" | "liegen-baenke" | "sessel" | "stuehle";

export type Project = {
  slug: string;
  cat: Category;
  title: string;
  alter?: string;
  zustand?: string;
  aufwand?: string;
  hours?: string;
  materials?: string;
  cover?: string;
  before?: string;
  after: string;
  extra?: string;
  // width / height of the after photo
  ratio: number;
  // built before ~1930, or a restoration: the "Antik & Restaurierung" filter
  antik?: boolean;
  badge?: "Referenz" | "Gastronomie";
};

export const projects: Project[] = [
  {
    "slug": "ecksofa-traditionell",
    "cat": "sofas",
    "title": "Ecksofa traditionell",
    "alter": "Um 1920",
    "zustand": "Polsterung defekt, Stoff fleckig und abgenutzt",
    "aufwand": "Die Kundin möchte ihr Sofa von uns fachgerecht restaurieren lassen, deshalb fertigen wir eine traditionelle Polsterung mit geschnürten Taillenfedern, Palmfaserfasson und Rosshaarpikierung an. Das Sofa wird dann mit einem Nesselstoff bezogen, um ein Weißpolster herzustellen und dann wird der Bezugsstoff angebracht.",
    "hours": "80 Stunden",
    "materials": "Jutegurte, Palmfasern, Stahlfedern, Rosshaar, Jutegewebe, Baumwollnessel",
    "cover": "Webstoff und abgesetzte Paspel im Rücken und Sitz",
    "before": "a7cca4dc0f6ea292809d6277915c9832",
    "after": "d4a0d3cc2191694bce63a03c12bf7820",
    "ratio": 1.6,
    "antik": true
  },
  {
    "slug": "sofa-mit-ueberbau-spaetes-19-jh",
    "cat": "sofas",
    "title": "Sofa mit Überbau (spätes 19. Jh)",
    "alter": "Spätes 19. Jahrhundert",
    "zustand": "Bezug und Polsterung defekt",
    "aufwand": "Der alte Bezug und die defekte Polsterung werden entfernt. Das Sofagestell wird verleimt und die Zargen mit Holzleisten verstärkt. Das Sofa wird mit einem angefertigten Federkern im Sitz und mit Schaumstoffen in verschiedenen Härtegraden aufgepolstert. Das Sofa wird komplett Bezogen und mit Paspel im Sitzbereich sowie Doppelkeder abgeschlossen.",
    "hours": "30 Stunden",
    "materials": "Gurte, nach Maß angefertigter Federkern, Schaumstoffe für Sitz, Rücken und Armlehnen",
    "cover": "Webstoff mit Muster aus Mischfasern und farblich passende Paspel und Doppelkeder",
    "before": "c7583ab303e5229460882ec7b5fbc803",
    "after": "6a9cdae421989658fdf6c944a64e6570",
    "ratio": 1.318,
    "antik": true
  },
  {
    "slug": "gruenderzeit-sofa",
    "cat": "sofas",
    "title": "Gründerzeit Sofa",
    "alter": "Um 1900",
    "zustand": "Polsterung defekt, Bezug gefällt nicht mehr",
    "aufwand": "Die Kundin wünscht eine fachgerechte Restaurierung ihres Sofas. Deshalb wird das Gründerzeitsofa, gemäß der Originalpolsterung, mit traditioneller Polstermethode und -materialien aufgepolstert. Auf die Jutegurtung wird die handgeschnürte Federung aufgebracht, auf diese dann die Fasson aus Palmfaser und die Pikierung aus Rosshaar. Das Sofa wird als Weißpolster gefertigt und dann mit Bezugsstoff aus zwei verschiedenen Stoffen bezogen.",
    "hours": "65 Stunden",
    "materials": "Jutegurte, Taillenfedern aus Stahl, Palmfaser, Rosshaar, Jutegewebe und Baumwollnessel",
    "cover": "Velours abgesetzt mit Satinstoff",
    "before": "d6792f2648850c05dd730efb9f1e63b6",
    "after": "9734170d97d869c1b90257383daba0bf",
    "ratio": 1.501,
    "antik": true
  },
  {
    "slug": "sofa-im-biedermeier-stil",
    "cat": "sofas",
    "title": "Sofa im Biedermeier Stil",
    "alter": "Ende 19./Anfang 20. Jahrhundert",
    "zustand": "Polsterung komplett defekt, Bezugsstoff alt und verschlissen",
    "aufwand": "Der Kunde entfernt eigenhändig die alte Polsterung und liefert uns das Gestell. Wir polstern das Sofa mit einem individuell angefertigten Federkern im Sitz und mit Schaumstoffen in verschiedenen Härtegraden auf, beziehen es komplett und schließen es mit einer Möbelborte ab.",
    "hours": "25 Stunden",
    "materials": "Gurte, individuell angefertigter Federkern, Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Stoff mit eingewebtem Muster und farblich passende Möbelborte",
    "before": "b5c930fc3399002dd56cc0e4ada5afd5",
    "after": "eec4263189a4812090b45bb2bed6aacd",
    "ratio": 1.501,
    "antik": true
  },
  {
    "slug": "sofa-ehemals-sessel",
    "cat": "sofas",
    "title": "Sofa ehemals Sessel",
    "alter": "Vermutlich ca. 60 – 80 Jahre alt",
    "aufwand": "Das Sofa war ursprünglich mal ein Sessel, welches ich auf dem Sperrmüll gefunden habe. Durch Entfernen des Stoffs und der Polsterung, konnte ich dann die Querhölzer des Rahmens durchtrennen und auf mein Wunschmaß verlängern und erhielt so ein kleines Sofa, welches perfekt in meine damalige 1-Zimmer Wohnung passte. Da das Sofa aber seitdem nicht mehr genutzt wurde und in diversen Lagern stand, war die Polsterung defekt und von Mäusen zerstört worden. Deshalb wurde das kleine Sofa komplett aufgepolstert und die Sitz- und Rückenauflage erneuert. Der Korpus wurde in einem Uni-Stoff bezogen mit kontrastfarbener Paspel, die Kissenauflagen erhielten einen Musterstoff, ebenfalls mit Paspel abgesetzt.",
    "hours": "25 Stunden",
    "materials": "Gurte, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Uni Samt (Korpus), Samt mit aufgedrucktem Muster (Kissen), Paspel aus Samtstoff",
    "after": "f9a260697692f155b0110597487bdb8c",
    "extra": "eba3ef330814886fed01d5527cea4d33",
    "ratio": 1.333
  },
  {
    "slug": "midcentury-klappsofa",
    "cat": "sofas",
    "title": "Midcentury Klappsofa",
    "alter": "Um 1950",
    "zustand": "Polsterung durchgesessen, Bezugsstoff nicht mehr schön",
    "aufwand": "Polsterung und Bezugsstoff werden entfernt. Da das Sofa ausgeklappt eine Liegefläche bildet, werden sowohl Rücken als auch Sitz mit Fedekernen und Schaumstoff aufgepolstert. Das Sofa wird bezogen, wobei die Sitz- und Rückenfläche mit Paspel abgesetzt und dreigeteilt wird.",
    "hours": "28 Stunden",
    "materials": "Auf Maß angefertigte Federkerne für Sitz und Rücken, Gurte, Schaumstoff",
    "cover": "Unifarbener Samt mit Paspel aus gemustertem Samtstoff",
    "before": "f7004e86216b36dc94163de82af44aa7",
    "after": "42d12756bdd2c646fd837a1a20d77609",
    "ratio": 1.626
  },
  {
    "slug": "louis-philippe-sofa",
    "cat": "sofas",
    "title": "Louis-Philippe Sofa",
    "alter": "Zweite Hälfte 19. Jahrhundert",
    "zustand": "Bezug stark verfleckt, Polsterung defekt",
    "aufwand": "Bezug und Polsterung werden entfernt. Da das Sofa selten benutzt wird, wünscht die Kundin aus Kostengründen eine reine Schaumstoffpolsterung, welche auf Gurten aufgebracht wird.",
    "hours": "40 Stunden",
    "materials": "Gurte, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Damastgewebe aus Viskose und passende Möbelborte",
    "before": "54e68887e1d4f178722e1d3128f8c23b",
    "after": "566b8534dd0dd98a821fb5202aabeeac",
    "ratio": 1.501,
    "antik": true
  },
  {
    "slug": "cassina-sofa-torso",
    "cat": "sofas",
    "title": "Cassina Sofa „Torso“",
    "alter": "1980er Jahre",
    "zustand": "Polsterung im Sitz durchgesessen, Bezug fleckig und zerschlissen.",
    "aufwand": "Der Sitzschaum wird durch einen neuen Kaltschaum ersetzt, Rücken und Armlehnpolster bleiben erhalten, neue Bezüge werden genäht und montiert.",
    "hours": "20 Stunden",
    "materials": "Kaltschaum (feste Sitzqualität), Vlies",
    "cover": "Uni Chenille (Sitz, Armlehnen und Keder), bunter Tupfenvelours (Rücken)",
    "before": "7a842ac4fbe37fbcc12c4a3a215d4ba7",
    "after": "82ba1c60c73d96f8bee028d3c45fb5ce",
    "ratio": 1.505
  },
  {
    "slug": "biedermeier-sofa-restaurierung",
    "cat": "sofas",
    "title": "Biedermeier Sofa (Restaurierung)",
    "alter": "Um 1880",
    "zustand": "Das Sofa wurde bereits vom Kunde komplett abgeschlagen und kam so als rohes Gestell zu uns.",
    "aufwand": "Das zum Teil kaputte Holzgestell wird an den lädierten Stellen mit Holzleisten verstärkt und verleimt. Der Sitz wird gegurtet und eine geschnürte Federung, Fasson und Pikierung werden mit traditionellen Techniken und Materialien angefertigt. Rücken und Armlehnen werden ebenfalls traditionell aufgearbeitet. Ein Weißbezug wird mit Nessel gefertigt, das komplette Sofa wird bezogen und eine Möbelborte bildet den Abschluss.",
    "hours": "65 Stunden",
    "materials": "Jutegurte, Taillenfedern, Jutegewebe, Palmfaser, Rosshaar, Nesselgewebe.",
    "cover": "Streifensatin aus Kunstfaser, Ripsbordüre",
    "before": "2d94f4d8b077a6bd8635e9108a41cc72",
    "after": "e35d675e6024bff2ccdaa54c1b5a4949",
    "ratio": 1.505,
    "antik": true
  },
  {
    "slug": "modernes-ecksofa",
    "cat": "sofas",
    "title": "Modernes Ecksofa",
    "alter": "Ca. 15 Jahre",
    "zustand": "Bezugsstoff abgenutzt und dunkelbraune Farbe gefällt nicht mehr. Da das Sofa umgestellt werden soll, sollen die Elemente spiegelverkehrt ummontiert werden.",
    "aufwand": "Die Gurte der Unterpolsterung werden erneuert. Bezüge werden angefertigt und montiert, Armlehnen und Befestigungsvorrichtungen werden getauscht, so dass das Sofa spiegelverkehrt zusammen montiert werden kann.",
    "hours": "25 Stunden",
    "materials": "Synthetikgurte, Filz, Vlies, Kleinmaterialien",
    "cover": "Webstoff mit Struktur aus Mischfasern",
    "before": "b9e1dacdc8aecd54ad22d77f0f0653c1",
    "after": "8b8681b916fd7bbdf24f7b926023f194",
    "ratio": 1.503
  },
  {
    "slug": "schlafsofa",
    "cat": "sofas",
    "title": "Schlafsofa",
    "alter": "Ca. 25 Jahre alt",
    "zustand": "Die Polsterung ist durchgesessen und der Bezug defekt.",
    "aufwand": "Die Polsterung in Sitz, Rücken und Armlehnen wird durch neuen Schaumstoff in den entsprechenden Härtegraden ersetzt, Bezüge werden angefertigt und montiert.",
    "hours": "25 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden, Vlies",
    "cover": "Pflegeleichter Synthetikstoff mit Fleckschutz",
    "before": "f063a3677c36fc19deb75d986343f1a4",
    "after": "7960ec4dfeb6574ec9bf452300c8b9f8",
    "ratio": 1.918
  },
  {
    "slug": "sofa-und-hocker-neuanfertigung-nach-kundenwunsch",
    "cat": "sofas",
    "title": "Sofa und Hocker – Neuanfertigung nach Kundenwunsch",
    "alter": "Neuanfertigung",
    "zustand": "Gestelle werden beim Gestellbauer nach Wunschmaß bestellt, ebenso die Füße für das Sofa und die Rollen für den Hocker",
    "aufwand": "Zusammen mit dem Kunde wird ein passendes Sofa- und Hockergestell ausgesucht. Da der Kunde zu starken Allergien neigt, werden die zu verarbeiteten Materialien sehr sorgfältig und nach Absprache ausgewählt. Auf Dinge wie Lacke und Klebstoffe wird gänzlich verzichtet. Sitzflächen werden mit Federkern und Schaumstoffen, Arm- und Rückenlehnen mit Schaumstoffen, Vlies und sythetischen Füllstoffen gepolstert.",
    "hours": "53 Stunden",
    "materials": "Polstergestelle aus Buchenholz, unlackiert, Füße und Rollen aus Edelstahl, Polsterung: synthetik Gurte, Schaumstoffe in verschiedenen Härtegraden, Vliese, Kissenfüllungen mit Synthetikfüllstoffen",
    "cover": "Baumwoll-/Leinenmischgewebe, waschbar",
    "after": "6c92bef93598ae48b75e5d0bd84c97bb",
    "ratio": 1.505
  },
  {
    "slug": "sofa-um-1880",
    "cat": "sofas",
    "title": "Sofa um 1880",
    "alter": "Ca. 1880",
    "zustand": "Polsterung defekt, Stoff abgenutzt",
    "aufwand": "Stoff und Polsterung werden entfernt und durch einen angefertigten Federkern im Sitz, sowie Schaumstoffe in diversen Härtegraden ersetzt. Das Sofa wird bezogen mit, einer drei-Teilung durch eingenähter Paspel im Rücken und mit farblich passendem Doppelkeder abgeschlossen.",
    "hours": "37 Stunden",
    "materials": "Nach Maß angefertigter Industriefederkern f. Sitz, Gurte, Schaumstoffe, Vliese",
    "cover": "Mustervelours aus Viscose/Polyester",
    "before": "de76a84756d339fabf4f9c9bd3f557f0",
    "after": "986ff21030ae67fe362f97ea9a2361da",
    "ratio": 1.503,
    "antik": true
  },
  {
    "slug": "sofa-um-1900",
    "cat": "sofas",
    "title": "Sofa um 1900",
    "alter": "Anfang 1900",
    "zustand": "Polsterung und Bezug defekt bzw. fehlend, Gestell wurde unprofessionell „nachlackiert“",
    "aufwand": "Die Farbe, welche auf das Gestell aufgebracht wurde, wird so gut es geht mit einem Abbeizer abgewaschen und das Holzgestell wird geölt. Die Polsterung wird mit Schaumstoff angefertigt. Das Sofa wird neu bezogen und mit Doppelkeder abgeschlossen.",
    "hours": "26 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Mustervelours aus Viscose",
    "before": "459c81963b59e3512839acd9592d0987",
    "after": "1937f25dffa867941cdd94b2deff446a",
    "ratio": 1.501,
    "antik": true
  },
  {
    "slug": "vollpolstersofa",
    "cat": "sofas",
    "title": "Vollpolstersofa",
    "alter": "Ca. 20-30 Jahre",
    "zustand": "Der Bezugsstoff ist zerschlissen, die Sitzkissen und die Unterpolsterung des Sofas sind durchgesessen.",
    "aufwand": "Der Stoff wird entfernt und die Unterpolsterung wird mit neuen Gurten und Schaumstoff aufgearbeitet, es werden neue Sitzkissen aus Schaumstoff angefertigt. Das Sofa wird bezogen und es werden fünf Zierkissen in verschiedenen Größen aus farblich passenden Stoffen mit verschiedenen Mustern angefertigt.",
    "hours": "30 Stunden",
    "materials": "Synthetikgurte und Schaumstoffe für die Unterpolsterung, Kaltschaum für die Sitzkissen.",
    "cover": "Muster-Webstoff aus Viskose, Baumwolle und Leinen",
    "after": "1b13d5d67c046c0cba8d415e13e11f5c",
    "ratio": 1.333
  },
  {
    "slug": "sofa-60er-jahre",
    "cat": "sofas",
    "title": "Sofa 60er Jahre",
    "alter": "Um 1960",
    "zustand": "Sitz und Rückenkissen komplett durchgesessen, Bezug und Holzgestell fleckig",
    "aufwand": "Nachdem der Kunde den Holzrahmen selbst aufgearbeitet hat, wird die Sitzfläche aufgepolstert (auf Wunsch etwas höher als die Originalpolsterung) und neue Rückenkissen werden angefertigt. Der Sitz wird bezogen und für die Rückenkissen werden Bezüge aus einem passenden Stoff mit anderem Muster angefertigt.",
    "hours": "15 Stunden",
    "materials": "Federkern, nach Maß angefertigt für Sitz, Schaumstoffe für Sitz und Rückenkissen.",
    "cover": "Streifen- und Punktevelours",
    "before": "9e745149f04516ae03697d6ba12c0b07",
    "after": "aa311dac8c8341e8b15f0453c18ad9b0",
    "ratio": 1.503
  },
  {
    "slug": "60er-jahre-sofa-mit-losen-polstern",
    "cat": "sofas",
    "title": "60er Jahre Sofa mit losen Polstern",
    "alter": "Um 1960",
    "zustand": "Die Unterpolsterung aus Metallfedern ist durchgesessen, Bezüge sind verfleckt und zerschlissen.",
    "aufwand": "Eine stabile Unterpolsterung stellen wir mit Gurten her und decken diese mit Polsterfilz ab, damit die darauf liegenden Kissen keinen Schaden nehmen. Neue Bezüge werden für die losen Sitz- und Rückenpolster genäht und bezogen. Ausserdem werden sechs Zierkissen in verschiedenen Musterstoffen und Größen angefertigt",
    "hours": "25 Stunden",
    "materials": "Synthetikgurte, Polsterfilz, Vlies",
    "cover": "Baumwoll-/Leinengewebe, bedruckte Stoffe aus Baumwolle und BW/Leinen für Zierkissen.",
    "before": "f947349b3e773aa99fa9a179c6a208c3",
    "after": "64424e5e44860d0e1014a2b7f5db3654",
    "ratio": 1.383
  },
  {
    "slug": "sofa-19-jahrhundert",
    "cat": "sofas",
    "title": "Sofa 19. Jahrhundert",
    "alter": "Um 1850",
    "zustand": "Bezugsstoff und Sitzpolsterung defekt, Rückenpolsterung und Armlehnkissen z.T. erhalten.",
    "aufwand": "Bezugsstoff und Sitzpolsterung werden entfernt. Die handgefertigte Bourletkante des Rückens und die Rosshaarfüllung der Armlehnkissen wird erhalten. Auf den gegurteten Sitz wird ein Federkern aufgebracht. Rücken-, und Sitzflächen werden aufgepolstert. Das Sofa wird bezogen und mit Doppelkeder abgeschlossen.",
    "hours": "41 Stunden",
    "materials": "Industriefederkern, latexierte Kokosmatte, Schaumstoffe, und Vliese.",
    "cover": "Baumwoll-/Viskosegewebe und farblich passendem Doppelkeder",
    "before": "ce7bbade4d1ae4677c76840604067a98",
    "after": "cdf5085c6b0f341a184365a28f75f015",
    "ratio": 1.333,
    "antik": true
  },
  {
    "slug": "rokoko-sofa-restaurierungsarbeit-fuer-das-schloss-ludwigsburg",
    "cat": "sofas",
    "title": "Rokoko-Sofa (Restaurierungsarbeit für das Schloss Ludwigsburg)",
    "alter": "Um 1750",
    "zustand": "Nur restauriertes, gefasstes Gestell vorhanden",
    "aufwand": "Restauratorische Polsterarbeit: Verarbeitung von traditionellen Materialien nach traditioneller Methode. Erhöhtes Fassonpolster (ohne Sprungfedern, nur durch Polstermaterial), Pikierung. Absolute Handarbeit – kein Tackern, Befestigung nur durch Nägel.",
    "hours": "53 Stunden",
    "materials": "Flachsfasson, Rosshaarpikierung, Baumwollwatte und Nesselbezug.",
    "cover": "Nach alter Vorlage angefertigter Seidenstoff, passende Gimpenborte.",
    "before": "0d09e1c6ce966759a8a47a452c693c2d",
    "after": "8099e3939136df61fd05bfe01df3db98",
    "ratio": 1.345,
    "antik": true,
    "badge": "Referenz"
  },
  {
    "slug": "baenke-fuer-die-wirtshausbrauerei-schwanenbraeu-filderstadt-bernhausen",
    "cat": "liegen-baenke",
    "title": "Bänke für die Wirtshausbrauerei Schwanenbräu, Filderstadt-Bernhausen",
    "alter": "Ursprünglich vermutlich von ca. 1950, zuletzt bezogen vor ca. 15-20 Jahren",
    "zustand": "Polster durchgesessen, Stoff zerschlissen",
    "aufwand": "Alle Bänke (und Stühle) der Gaststube „Bierhimmel“ werde von uns demontiert. Die defekten Polsterflächen werden entfernt, durch neuen Schaumstoff ersetzt und komplett bezogen. Die großen Bänke erhalten einen blauen, die kleineren Bänke und die Stühle einen blau-gemusterten Bezug.",
    "hours": "68 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Tuchgewebe aus Wolle",
    "before": "a1a89f2bb4c9a7852ae889c6a3d19de2",
    "after": "460e93b3073b9c0d7e0ad54bda4db4fc",
    "ratio": 1.342,
    "badge": "Gastronomie"
  },
  {
    "slug": "rundbank",
    "cat": "liegen-baenke",
    "title": "Rundbank",
    "alter": "Ca. 30 Jahre alt",
    "zustand": "Polster durchgesessen, Bezugsstoff gefällt nicht mehr",
    "aufwand": "Durch die Rundung der Bank, sind alle Kissen unterschiedlich groß und deshalb fertigen wir vorher Schablonen vor Ort an. Die alten Polster sind zu verzogen und durchgesessen um sie als Vorlage zu verwenden. Ausserdem möchte der Kunde aus Komfortgründen angepasste Rückenkissen, anstelle der vorhandenen Spitzkissen. Neue Kissen werden aus Schaumstoff angepasst und angefertigt, Bezüge dafür genäht und montiert.",
    "hours": "25 Stunden",
    "materials": "Schaumstoffzuschnitte auf Maß in verschiedenen Härtegraden",
    "cover": "Pflegeleichte Mikrofaser in Lederoptik",
    "before": "c87753b2e64b46cb47ece3c2b13b2c87",
    "after": "a635ab02efbb0c4cef4afdac9fbbce1f",
    "ratio": 1.598
  },
  {
    "slug": "sofabank",
    "cat": "liegen-baenke",
    "title": "Sofabank",
    "alter": "Ca. 100 Jahre alt",
    "zustand": "Diese Bank wurde irgendwann einmal komplett zugepolstert. Die Kundin hat dieses Polster entfernt und ein Schreiner das Holz aufgearbeitet, danach kam die Bank zu uns in die Polsterei.",
    "aufwand": "Das mit Holz überplattete Sitzgestell wird mit einer Schaumstoffpolsterung aufgebaut, der Rücken wird ebenfalls mit Schaum gepolstert. Bezüge werden angebracht und mit einem passenden Doppelkeder abgeschlossen.",
    "hours": "10 Stunden",
    "materials": "Schaumstoffe in Sitz- und Rückenqualität",
    "cover": "Baumwoll-/Leinenstoff mit eingewebtem Muster, Doppelkeder",
    "after": "1d3bbadf08e743bd804fdd47eaec9689",
    "ratio": 1.505,
    "antik": true
  },
  {
    "slug": "baenke-und-stuehle-des-rotostueble-fa-roto-frank-ag",
    "cat": "liegen-baenke",
    "title": "Bänke und Stühle des Rotostüble (Fa. Roto Frank AG)",
    "alter": "Ca. 10 Jahre",
    "zustand": "Kunstlederbezug defekt, Polsterung noch in Ordnung",
    "aufwand": "Neue Bezüge werden nach Vorlage genäht und montiert.",
    "hours": "45 Stunden",
    "materials": "Vlies zum Abdecken der Oberpolsterung",
    "cover": "Schwer entflammbares Gewebe aus 100 % Polyester",
    "before": "c5c75483b83842d1a005aa4026cbcc3f",
    "after": "99e51998dbd10d7961d3873e91f60a01",
    "ratio": 1.64,
    "badge": "Gastronomie"
  },
  {
    "slug": "eckbankgarnitur",
    "cat": "liegen-baenke",
    "title": "Eckbankgarnitur",
    "alter": "Ca. 40-50 Jahre",
    "zustand": "Holzfarbe gefällt dem Kunde nicht, Stoff und Polsterung defekt",
    "aufwand": "In Zusammenarbeit mit einem Maler/Lackierer, wird der Farbton des Lackes passend zum neuen Bezugsstoff ausgesucht. Nach dem Entfernen des alten Stoffs und der Polsterung, werden alle Holzflächen inkl. des Tischs umlackiert. Bankelemente und Stühle werden mit Schaumstoff aufgepolstert und mit verschiedenen, in ein Farbthema passenden Stoffen bezogen. Die Rücken der Stühle werden mit farblich passendem Doppelkeder versehen.",
    "hours": "20 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden, Vlies",
    "cover": "Streifen- und farblich abgestimmte Unistoffe aus Baumwoll-/Leinen-/Synthetikmischgewebe",
    "before": "402ecb8c3d027b9e326386fc57997d8b",
    "after": "3af497e1f49a874094ba72e03d8aff9c",
    "ratio": 1.333
  },
  {
    "slug": "chaiselongue",
    "cat": "liegen-baenke",
    "title": "Chaiselongue",
    "alter": "Ca. 1930",
    "zustand": "Polsterung und Bezugsstoff defekt",
    "aufwand": "Die alte Polsterung wird komplett entfernt. Der Sitz wird mit einem angefertigtem Federkern und Schaumstoff aufgepolstert, Rücken- und Armlehne mit Schaumstoffen in verschiedenen Härtegraden. Der Rücken wird mit einem Musterstoff der Stilepoche der Wiener Werkstätte (original Design), passend zu einem vorhandenen Sessel bezogen, Arm- und Rückenlehne in einem passenden Uni.",
    "hours": "25 Stunden",
    "materials": "Federkern, nach Maß angefertigt im Sitz, Schaumstoffe für Sitz, Rücken- und Armlehnbereich.",
    "cover": "Musterstoff nach original Design der Wiener Werkstätte, Uni-Chenille (beide Stoffe aus 100% Polyester)",
    "before": "5f900c81de1bfb472bea10e48c99a61d",
    "after": "09d2ccc12c117b7a70d554491652055f",
    "ratio": 1.503,
    "antik": true
  },
  {
    "slug": "eckbank-3-bankelemente-u-3-stuehle",
    "cat": "liegen-baenke",
    "title": "Eckbank (3 Bankelemente u. 3 Stühle)",
    "alter": "Ca. 20-30 Jahre",
    "zustand": "Bezugsstoff und Polsterung defekt, Holzrahmen an manchen Stellen abgeriffen, besonders bei den Stuhllehnen.",
    "aufwand": "Stoff und Polsterung werden entfernt. Die abgegriffenen Stellen der Holzrahmen werden gesäubert, leicht angeschliffen und überlackiert. Rücken und Sitzflächen werden aufgepolstert und bezogen.",
    "hours": "25 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Mustervelours mit Farbverlauf auf den Rückenlehnen, Uni-Chenille auf Sitzflächen",
    "after": "30efb79e1dc48984e50523048010790c",
    "ratio": 1.333
  },
  {
    "slug": "restaurantbaenke-des-wyndham-hotel-flughafen-stuttgart",
    "cat": "liegen-baenke",
    "title": "Restaurantbänke des Wyndham Hotel, Flughafen Stuttgart",
    "alter": "Ca. 5 Jahre",
    "zustand": "Bezüge fleckig und kaputt, Polsterung zu weich und zu niedrig in Relation zu den Esstischen.",
    "aufwand": "Die Sitzbänke werden abmontiert und ein höherer und festerer Schaum wird aufgeklebt. Bezüge werden nach Vorlage genäht und angebracht. Die Sitzbänke werden geliefert und vor Ort montiert.",
    "materials": "Schaumstoff in Sitzqualität",
    "cover": "Schwer entflammbarer Musterstoff aus 100% Polyester",
    "after": "37adeaaa53f4ca1987df9fd19b538079",
    "ratio": 1.333,
    "badge": "Gastronomie"
  },
  {
    "slug": "ofenbank",
    "cat": "liegen-baenke",
    "title": "Ofenbank",
    "alter": "Ca. 20 – 30 Jahre",
    "zustand": "Polsterung und Bezugsstoff durchgesessen",
    "aufwand": "Die Sitzflächen werden aufgepolstert und neu bezogen. 6,5 Arbeitsstunden",
    "materials": "Schaumstoff in Sitzqualität",
    "cover": "Musterstoff aus Synthetikgewebe",
    "after": "87783d39915d924724aa231420a62691",
    "ratio": 1.333
  },
  {
    "slug": "einbaueckbank",
    "cat": "liegen-baenke",
    "title": "Einbaueckbank",
    "alter": "Ca. 20 Jahre",
    "zustand": "Stoff und Polsterung durchgesessen",
    "aufwand": "Sitz- und Rückenpolster werden abmontiert und mit neuen Schaumstoffen versehen. Zwei dazugehörige Stühle werden ebenfalls neu aufgepolstert. Alle Polsterflächen erhalten einen neuen Bezug und werden vor Ort wieder montiert.",
    "hours": "18 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Mustergewebe aus Mischfasern",
    "after": "efe8df1129e2db1510a830a774629ba3",
    "ratio": 1.333
  },
  {
    "slug": "recamiere-restaurierung",
    "cat": "liegen-baenke",
    "title": "Recamiere – Restaurierung",
    "alter": "Ca. 1900",
    "zustand": "Sitzpolsterung defekt, Armlehn- und Rückenpolster können erhalten werden.",
    "aufwand": "Das Sitzpolster der Recamiere wird aus handgeschnürten Taillenfedern, Palmfaserfasson und Rosshaarpikierung hergestellt. Sitz- und Rückenpolster sind intakt und werden lediglich mit einer neuen Baumwollwatte abgedeckt. Alle Polsterflächen werden mit einem Nesselbezug versehen, als Weißpolster gefertigt, anschließend in verschiedenen Grüntönen bezogen und mit einem zwei-farbigen Doppelkeder abgeschlossen.",
    "hours": "34 Stunden",
    "materials": "Jutegurte, Palmfaser, Taillensprungfedern, Rosshaar, Jutegewebe, Baumwollwatte",
    "cover": "Leinen-/Baumwollmischgewebe in drei verschiedenen Grüntönen",
    "after": "ac3c23e90bd055b1820b3a547fb8c318",
    "ratio": 1.505,
    "antik": true
  },
  {
    "slug": "recamiere",
    "cat": "liegen-baenke",
    "title": "Recamiere",
    "alter": "Um 1930",
    "zustand": "Bezugsstoff defekt, Polsterung komplett durchgesessen",
    "aufwand": "Stoff und Polsterung werden entfernt, so dass nur noch das nackte Holzgestell vorhanden ist. Hier wird neu aufgepolstert: mit Gurten, Federkern im Sitz, Schaumstoffen im Sitz und in Arm- und Rückenlehnen. Alle Polsterflächen werden mit verschiedenen Stoffen bezogen und mit einer Paspel abgesetzt.",
    "hours": "35 Stunden",
    "materials": "Federkern auf Maß angefertigt für Sitz, Schaumstoff in verschiedenen Härtegraden für Sitz, Rücken- und Armlehnen",
    "cover": "Sitz-Webstoff, Armlehne links: breiter Cordsamt, Rücken und Armlehne rechts: Mustervelours (alle Stoffe Viskose bzw. Viskose Mischfaser)",
    "before": "6ed727859d2c8acb200d3cb17cbefd67",
    "after": "1525fbb5fe9bf56d56f9e731548f2766",
    "ratio": 1.503,
    "antik": true
  },
  {
    "slug": "recamiere-gruen",
    "cat": "liegen-baenke",
    "title": "Recamiere grün",
    "alter": "1930",
    "zustand": "Stoff und Polsterung komplett defekt.",
    "aufwand": "Entfernen des Polsters. Traditionelles Aufpolstern des gesamten Möbels. Schleifen, Beizen und Lackieren von Holzfüßen.",
    "hours": "83 Stunden",
    "materials": "Industriefederkern im Sitz, handgeschnürte Federung in Rücken- und Armlehnen. Darauf aufgebaut: Palmfaserfasson, Rosshaarpikierung, Schafwollabdeckung und Nesselbezug.",
    "cover": "Microfaserbezugsstoff mit farblich abgestimmter Paspelierung.",
    "before": "c9bbdfbf1d3abbfb0ac2ee937f8e81ae",
    "after": "0a5c1e00da91cb274a59e87e60cbed30",
    "ratio": 1.333,
    "antik": true
  },
  {
    "slug": "cocktailsessel-gemustert",
    "cat": "sessel",
    "title": "Cocktailsessel gemustert",
    "alter": "1950 – 1960",
    "zustand": "Polsterung und Bezug defekt",
    "aufwand": "Polsterung und Bezug werden komplett entfernt. Die Kundin entscheidet sich für eine reine Schaumstoffpolsterung ohne Federkern. Bezüge werden aus verschiedenen Stoffen gefertigt und bezogen, zusätzlich werden noch vier Kissenbezüge genäht.",
    "hours": "12 Stunden",
    "materials": "Synthetikgurte, Schaumstoff in verschiedenen Härtegraden.",
    "cover": "Bedruckter gemusterter Baumwollstoff, synthetik Velours in passenden Farben",
    "before": "a5dbe8e7481af3473663af80f90c309e",
    "after": "efff32b183e615a8da7386e6d028e498",
    "ratio": 0.768
  },
  {
    "slug": "ohrensessel-schwarz-weiss-mit-hocker",
    "cat": "sessel",
    "title": "Ohrensessel schwarz/weiß mit Hocker",
    "alter": "Ca. 20 Jahre",
    "zustand": "Stoff gefällt nicht mehr, Polsterung ist teilweise defekt",
    "aufwand": "Der Bezug wird komplett entfernt, Armlehnpolsterungen werden komplett, Sitz- und Rückenpolsterung teilweise ersetzt. Sessel und Hocker werden komplett bezogen.",
    "hours": "26 Stunden",
    "materials": "Gurte, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Webstoff aus Natur- und Kunstfasern",
    "before": "5b39e9d10fe889e35a5c958c55d7747c",
    "after": "b6360e691ba782af21c0102b950ef857",
    "ratio": 0.745
  },
  {
    "slug": "designer-sessel-leolux-papageno",
    "cat": "sessel",
    "title": "Designer Sessel Leolux Papageno",
    "alter": "Ca. 20 Jahre",
    "zustand": "Stoff kaputt/zerschlissen",
    "aufwand": "Der defekte Bezug wird entfernt und es wird der Zuschnitt ermittelt, die vorhandene Polsterung wird mit Vlies abgedeckt. Die Teile des Bezugs werden zugseschnitten und zusammengenäht und letztendlich auf den Sessel montiert. 9,5 Arbeitsstunden",
    "materials": "Vlies und Kleinmaterial",
    "cover": "Microfaser",
    "before": "7fb447c57dbb98741faab6eef50a1095",
    "after": "fd5eedf4daf609ef0691ab908bb1ff55",
    "ratio": 0.792
  },
  {
    "slug": "sessel-mit-streifenbezug-und-paspel",
    "cat": "sessel",
    "title": "Sessel mit Streifenbezug und Paspel",
    "alter": "Ca. 120 Jahre alt",
    "zustand": "Polsterung defekt, Gestell wackelt, Bezug fleckig und nicht mehr schön",
    "aufwand": "Nachdem die alte und sehr bröselige Polsterung entfernt wird, muss das Gestell verleimt und einer der Füße neu verschraubt werden. Der Sitzaufbau beinhaltet einen auf Maß angefertigten Federkern, der restliche Sessel wird mit Gurten und Schaumstoff aufgepolstert. Die Bezüge werden mit Paspel angefertigt und bezogen.",
    "hours": "22 Stunden",
    "materials": "Auf Maß angefertigter Federkern, Schaumstoffe in verschiedenen Härtegraden, Gurte",
    "cover": "Leinenstoff mit eingewebtem Streifenmuster, farblich passende Fertigpaspel",
    "before": "c4b605de07839c15413a3cc42562bec9",
    "after": "250234a6836c87e6dc997102615078f9",
    "ratio": 0.801,
    "antik": true
  },
  {
    "slug": "lila-thron-sessel",
    "cat": "sessel",
    "title": "Lila Thron Sessel",
    "alter": "Ca. 15 – 20 Jahre alt",
    "zustand": "Polster durchgesessen, Bezug fleckig",
    "aufwand": "Alte Bezüge und Polster werden entfernt. Sitz und Rücken werden mit neuen Gurten und Schaumstoffen aufgepolstert. Der Sessel wird bezogen, der Rücken mit Knöpfen abgeheftet und der Bezug unten und hinten mit Ziernägeln abgeschlossen.",
    "hours": "13 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden, Gurte, Polsterknöpfe und Ziernägel",
    "cover": "Samt aus 100% Polyester",
    "after": "6685655ec8572392ccfc784d35081afe",
    "ratio": 0.665
  },
  {
    "slug": "louis-xv-sessel",
    "cat": "sessel",
    "title": "Louis XV Sessel",
    "alter": "Unbekannt",
    "zustand": "Sitzpolsterung defekt, Stoff nicht mehr schön",
    "aufwand": "Stoff und Polsterung werden entfernt. Der Sitz wird mit Federkorb und Schaumstoff aufgepolstert. Alle Polsterflächen werden bezogen, wobei der Sitz und Rücken vorne mit Musterstoff, die Armlehnen und der Rücken hinten mit einem farblich passenden Uni-Stoff versehen werden. Den Abschluss bildet ein kontrastfarbiger Doppelkeder. Aus dem Uni-Stoff wird ein Kissen mit kontrastfarbiger Paspel genäht. 14,5 Arbeitsstunden",
    "materials": "Federkorb, Gurte, Schaumstoff, Vlies, Pappe",
    "cover": "Muster Velours mit Hoch-/Tiefstruktur und Uni Velours aus Viscose/Polyester, kontrastfarbiger Doppelkeder/Paspel",
    "before": "7a1b312149df89ea36302a23233f9b9c",
    "after": "cbcc3f73fb7f50f80d136388c311a222",
    "ratio": 0.768
  },
  {
    "slug": "vollpolstersessel-um-1960-in-pink",
    "cat": "sessel",
    "title": "Vollpolstersessel um 1960 in Pink",
    "alter": "Um 1960",
    "zustand": "Polsterung defekt, Stoff fleckig und nicht mehr schön",
    "aufwand": "Die alte Polsterung wird, bis auf den Rücken, komplett entfernt. Da der Sessel im Schlafzimmer stehen soll und nicht intensiv genutzt wird, entscheidet sich die Kundin für eine reine Schaumstoffpolsterung ohne Federkern im Sitz. Die Armlehnen werden ebenfalls mit Schaumstoff gepolstert und die Rückenpolsterung damit abgedeckt. Der Sessel wird komplett bezogen und mit einer helleren Paspel als Kontrast abgesetzt.",
    "hours": "18 Stunden",
    "materials": "Synthetikgurte, Polsterfilz, Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Webstoff aus Baumwolle/Leinen",
    "before": "d9f965e4dd9cc927e4bc95f158a9a789",
    "after": "1860c01802eceee621b1881da45eade5",
    "ratio": 0.75
  },
  {
    "slug": "drei-retro-sessel-um-1950-mit-losen-kissen",
    "cat": "sessel",
    "title": "Drei Retro Sessel um 1950 mit losen Kissen",
    "alter": "Ca. 1950, evtl. auch etwas früher",
    "zustand": "Stoff verschlissen, Sitz- und Rückenkissen, sowie die Unterpolsterung aus Flachfedern im Sesselgestell sind durchgesessen.",
    "aufwand": "Die Unterpolsterung in den Gestellen aus flachen Metallfedern, wird entfernt und durch Gurte ersetzt, neue Schaumstoffzuschnitte bilden die Innenleben der neuen, losen Kissen. Bezüge werden genäht und angebracht und das Holz der Gestelle aufpoliert.",
    "hours": "20 Stunden",
    "materials": "Schaumstoffzuschnitte aus verschiedenen Härtegraden, Gurte",
    "cover": "Velours sowie Webstoff aus Mischfasern im Retro-Look",
    "after": "0143154a49aa1ea562d02ae650dca16e",
    "ratio": 0.75
  },
  {
    "slug": "zwei-mid-century-sessel-mit-losen-kissen",
    "cat": "sessel",
    "title": "Zwei Mid-Century Sessel mit losen Kissen",
    "alter": "Um 1960",
    "zustand": "Polster durchgesessen und Stoff nicht mehr schön",
    "aufwand": "Neue Sitz- und Rückenkissen werden auf Maß angefertigt, der Sitz erhält einen Federkern. Bezüge werden genäht und montiert.",
    "hours": "15 Stunden",
    "materials": "Zylinderfederkerne auf Maß angefertigt, Schaumstoffzuschnitte in verschiedenen Härtegraden.",
    "cover": "Polyester-/Viskosemischung mit eingewebten Mustern",
    "after": "0ef779a471f9a50dd18f69ffe181e5ed",
    "extra": "a19240839ed32b7d36d12dd7c3f935da",
    "ratio": 0.665
  },
  {
    "slug": "vollpolstersessel-knuff",
    "cat": "sessel",
    "title": "Vollpolstersessel „Knuff“",
    "alter": "Ca. 20 Jahre",
    "zustand": "Bezugsstoff ausgebleicht und abgewetzt, Polsterung teilweise durchgesessen.",
    "aufwand": "Bezugsstoff und Polsterung werden entfernt, die Unterpolsterung aus Gummigurten wird erneuert und die Polsterung bzw. die Oberpolsterung wird ersetzt. Bezüge werden genäht und montiert.",
    "hours": "24 Stunden",
    "materials": "Gummigurte, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Bedrucktes Baumwollgewebe",
    "after": "1f0fe8465126097d93b381dca940f7c9",
    "ratio": 0.818
  },
  {
    "slug": "designer-sessel-gaensefuesschen-mit-hocker",
    "cat": "sessel",
    "title": "Designer Sessel „Gänsefüsschen“ mit Hocker",
    "alter": "Ca. 15 Jahre",
    "zustand": "Bezugsstoff defekt und fleckig. Sitzschaum durchgesessen.",
    "aufwand": "Bezüge werden entfernt und als Mustervorlage aufgetrennt. Der Sitzschaum wird erneuert. Die Neuen Bezüge werden nach Vorlage angefertigt und montiert.",
    "hours": "23 Stunden",
    "materials": "Schaumstoff und Schaumvlies.",
    "cover": "Polyesterchenille im „Tigerstreifen-Look“",
    "before": "7178555fa2582e2496497fdf128d22ef",
    "after": "c752bf8239c977ddab1e0ad5e83876d9",
    "ratio": 1.333
  },
  {
    "slug": "cocktailsessel-mit-lackierten-holzarmlehnen",
    "cat": "sessel",
    "title": "Cocktailsessel mit lackierten Holzarmlehnen",
    "alter": "Um 1950-1960",
    "zustand": "Holz nicht mehr schön, Polster und Bezug defekt",
    "aufwand": "Dieser Cocktailsessel wird für unsere Ausstellung angefertigt. Zuerst entfernen wir das alte Polster und den Bezugsstoff. Dann lackiert der Maler nach dem Farbton des ausgesuchten Stoffs der Paspelierung, die Armlehnen und Füße des Gestells. Der Sessel bekommt einen Federkern als Sitzunterpolsterung und wird dann mit verschiedenen Schaumstoffen aufgepolstert. Bezüge mit abgesetzter Paspel werden angebracht.",
    "hours": "15 Stunden",
    "materials": "Nach Maß angefertigter Industriefederkern, Gurte, Schaumstoffe in verschiedenen Härtegraden, Vliese",
    "cover": "Mustervelours aus Mischgewebe",
    "before": "978f6c5f5c7e81a82ef656845e65127e",
    "after": "66bc6ef7b7f6c5715b4c62dd759861ad",
    "ratio": 0.75
  },
  {
    "slug": "zwei-louis-philippe-sessel-restaurierung",
    "cat": "sessel",
    "title": "Zwei Louis-Philippe Sessel – Restaurierung",
    "alter": "2. Hälfte 19. Jahrhundert",
    "zustand": "Polster und Bezug defekt",
    "aufwand": "Beide Sessel werden bis auf das Holzgestell abgeschlagen. Die Gestelle werden verleimt. Die Polster werden nach traditioneller Methode mit geschnürter Taillenfederung, Palmfaserfasson und Rosshaarpikierung restauriert. Im Rücken wird eine sogenannte Capitonne Heftung angefertigt und alle Polsterflächen werden als „Weißpolster“ mit Nessel bezogen. Die Sessel werden dann mit Velours bezogen und mit passender Bordüre abgeschlossen.",
    "hours": "52 Stunden",
    "materials": "Jutegurte, Taillensprungfedern, Jutegewebe, Palmfaser (Afrik), Rosshaar, Baumwollwatte, Nesselstoff",
    "cover": "Mohair Velours",
    "before": "f4a586195478a4afe544dd40ecc3e48f",
    "after": "210229e375f403153f86793fb99690f4",
    "ratio": 0.75,
    "antik": true
  },
  {
    "slug": "ledersessel-mit-rueckenheftung",
    "cat": "sessel",
    "title": "Ledersessel mit Rückenheftung",
    "alter": "Ca. 60 Jahre",
    "zustand": "Polsterung defekt, Stoff wurde mehrmals über alte Polsterungen bezogen, dabei ging die Ursprüngliche Form verloren.",
    "aufwand": "Die Polsterung wird komplett entfernt und mit modernen Materialien neu aufgebaut. Der Sessel wird so bezogen, dass er seine Ursprungsform als Ohrensessel wieder zurückbekommt, der Rücken wird mit Knöpfen abgeheftet.",
    "hours": "38 Stunden",
    "materials": "Federkern im Sitz, Polstergurte, Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Ecopell Bio-Leder",
    "before": "ef62f2efd34e12692fd4251ece602de4",
    "after": "1550564d6e63001e67e0f8370e82b2ac",
    "ratio": 0.946
  },
  {
    "slug": "ohrensessel-und-hocker-mit-streifenstoff",
    "cat": "sessel",
    "title": "Ohrensessel und Hocker mit Streifenstoff",
    "alter": "Ca. 30 Jahre",
    "zustand": "Polsterung durchgesessen, Bezugsstoff kaputt.",
    "aufwand": "Der Bezugsstoff und die Polsterung werden entfernt. Sessel und Hocker werden komplett neu aufgepolstert und bezogen.",
    "hours": "30 Stunden",
    "materials": "Polstergurte, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Leinenstoffe mit Streifenmuster in zwei verschiedenen Breiten",
    "before": "c7ae42e884dc4f5e050e65c29a7f6b50",
    "after": "80eeb3d4003eb9d35c6e099cff3d4720",
    "ratio": 0.941
  },
  {
    "slug": "alter-ohrensessel-mit-sichtholz",
    "cat": "sessel",
    "title": "Alter Ohrensessel mit Sichtholz",
    "alter": "Ca. 100- 120 Jahre",
    "zustand": "Polsterung defekt, Stoff fleckig, Sitzkissen durchgesessen.",
    "aufwand": "Die alten Polsterstoffe, sowie die defekte Polsterung, werden entfernt. Ein neues Sitzkissen wird nach Maß angefertigt. Der Sessel wird komplett bezogen und der Bezug mit passender Paspel für das Sitzkissen genäht. Ziernägel werden als Abschluss eingeschlagen.",
    "hours": "23 Stunden",
    "materials": "Polstergurte, Schaumstoffe in verschiedenen Härtegraden, „Sandwichkissen“ Sonderanfertigung: Daunenkissen mit Kaltschaumkern für Sitzbereich.",
    "cover": "Mustervelours",
    "before": "d13337ce7e9b649b76527daae208eb36",
    "after": "4744f72389ab64d1a4479462747654ff",
    "ratio": 0.751,
    "antik": true
  },
  {
    "slug": "sessel-im-voltaire-stil",
    "cat": "sessel",
    "title": "Sessel im Voltaire Stil",
    "alter": "Unbekannt",
    "zustand": "Polsterung durchgesessen, Stoff abgenutzt, Lackierung des Polstergestell abgeblättert.",
    "aufwand": "Stoff und Polsterung werden komplett entfernt. Das Holzgestell wird abgebeizt, geschliffen, mit dunkler Beize behandelt und lackiert. Die Polsterung wird mit Gurten und Schaumstoffen aufgebaut und der Sessel wird komplett bezogen. Den Abschluss bildet eine Gimpenborte.",
    "hours": "16 Stunden",
    "materials": "Polstergurte, Schaumstoffe in verschiedenen Härtegraden, Holzbeize und Klarlack auf Wasserbasis.",
    "cover": "Damaststoff und farblich passende Gimpenborte",
    "before": "e0abd02a2f0d995785a2420b3970fb8b",
    "after": "21cae23d65070346b7ec00a9f26b4076",
    "ratio": 0.711
  },
  {
    "slug": "breiter-ohrensessel",
    "cat": "sessel",
    "title": "Breiter Ohrensessel",
    "alter": "Unbekannt",
    "zustand": "Oberpolsterung durchgesessen, Bezugsstoff alt und gefällt nicht mehr",
    "aufwand": "Stoff und Oberpolsterung werden entfernt. Neue Schaumstoffe ersetzen die alte Oberpolsterung, der Bezugsstoff wird quer auf Rapport verarbeitet: zugeschnitten, genäht und bezogen.",
    "hours": "27 Stunden",
    "materials": "Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Gewebter Streifen-Stoff aus Mischfasern",
    "before": "56ba6a492a0b1bf40479064a78262f5f",
    "after": "d59d638ef19f29edd896ba035dfa48b0",
    "ratio": 0.665
  },
  {
    "slug": "cocktailsessel",
    "cat": "sessel",
    "title": "Cocktailsessel",
    "alter": "1950 – 1960",
    "zustand": "Polsterungen und Bezugsstoffe defekt",
    "aufwand": "Stoffe und Polsterungen werden entfernt. Die Sitzflächen werden mit Federkernen und Schaumstoff aufgepolstert, die Rückenlehnen mit Schaumstoffen. Die Bezüge werden genäht und angebracht.",
    "hours": "23 Stunden",
    "materials": "Polstergurte, nach Schablone angefertigte Federkerne, Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Baumwoll-/Viscose Chenille",
    "before": "918859679839e2a66ee1ba7a0d870e4e",
    "after": "e8c7621499a69f3e9338695ddf960cb2",
    "ratio": 0.857
  },
  {
    "slug": "traditioneller-sessel-in-modernem-look",
    "cat": "sessel",
    "title": "Traditioneller Sessel in modernem Look",
    "alter": "Ca. 100 – 120 Jahre",
    "zustand": "Der Lederbezug ist eingerissen und löchrig, Sitz- und Armlehnpolsterungen sind duchgesessen.",
    "aufwand": "Der Kunde entfernt den defekten Bezug und das Polstermaterial auf Sitzfläche und Armlehnen. Bei uns wird der Sessel aufgepolstert (Armlehnen und Sitz – die Rückenpolsterung können wir erhalten) und bezogen.",
    "hours": "23 Stunden",
    "materials": "Maßangefertigter Federkern im Sitz, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Mustervelours (Innenseite des Sessels), Chenille Uni-farben (Aussenteile des Sessels und Keder)",
    "before": "f404d2f4751767adad6a74cc6199823b",
    "after": "f97168f2c51b67c7317792a56e78764a",
    "ratio": 0.665,
    "antik": true
  },
  {
    "slug": "cocktailsessel-mit-armlehnen",
    "cat": "sessel",
    "title": "Cocktailsessel mit Armlehnen",
    "alter": "Zwischen 1950 – 1960",
    "zustand": "Stoff und Polsterung komplett durchgesessen/defekt",
    "aufwand": "Alter Stoff und Polsterung werden komplett entfernt. Der Sitz wird mit Gurten, einem Federkern und Schaumstoff aufgepolstert, Rücken und Armlehnen mit neuem Schaumstoff versehen. Der Sessel wird komplett neu bezogen.",
    "hours": "22 Stunden",
    "materials": "Gurte, nach Schablone angefertigter Federkern im Sitz, Schaumstoffe in verschiedenen Härtegraden.",
    "cover": "Musterveloure mit verschiedenen Dessins, farblich zueinander passend, farblich passender Fertigkeder.",
    "after": "296b4dac90438d0d2a0be6102fa28075",
    "ratio": 0.945
  },
  {
    "slug": "lamino-chair-mit-veganem-schaffellbezug",
    "cat": "stuehle",
    "title": "Lamino Chair mit veganem Schaffellbezug",
    "alter": "1950/60er Jahre",
    "zustand": "Der original Schaffellbezug sowie der Unterstoff sind zerschlissen.",
    "aufwand": "Bezug und Unterbezug werden entfernt und ersetzt. 4,5 Arbeitsstunden",
    "materials": "Unterkonstruktion aus Outdoor Stoff 100% Polyacryl Bezugsstoff im Schaffellook aus 100% recyceltem Polyester",
    "before": "4ca6914b0e7ba1fe79da10418e9d398e",
    "after": "f5b26c1841f45efdb9a121b183047b42",
    "ratio": 0.8
  },
  {
    "slug": "zwei-stuehle-spaetes-19-jahrhundert",
    "cat": "stuehle",
    "title": "Zwei Stühle spätes 19. Jahrhundert",
    "alter": "Um 1900",
    "zustand": "Die Sitzflächen der Stühle bestehen aus Rohrgeflecht, welches gebrochen ist",
    "aufwand": "Das kaputte Geflecht wird entfernt und mit einer Platte aus Multiplex ersetzt. Der Sitz wird mit Schaumstoff flach aufgepolstert, bezogen und mit Doppelkeder abgeschlossen.",
    "hours": "5 Stunden",
    "materials": "Multiplex Holzplatte, Schaumstoff, Vlies",
    "cover": "Tupfenvelours mit farblich passendem Doppelkeder",
    "after": "402fbe5fb9f8fd0a517bd72b9b79127c",
    "extra": "4933d8d06b39f55da85b6615561d2708",
    "ratio": 1.5,
    "antik": true
  },
  {
    "slug": "vier-esszimmerstuehle-mit-gepolsterten-ruecken-und-sitzflaechen",
    "cat": "stuehle",
    "title": "Vier Esszimmerstühle mit gepolsterten Rücken- und Sitzflächen",
    "alter": "Ca. 25 Jahre alt",
    "zustand": "Polster und Bezug durchgesessen",
    "aufwand": "Sitz- und Rückenflächen werden mit neuem Schaumstoff aufgepolstert und mit Stoff bezogen.",
    "hours": "14 Stunden",
    "materials": "Schaumstoffe für Sitz und Rücken",
    "cover": "Gewebter Chenillestoff mit Blumenmuster",
    "after": "3a3058e633311b52c532a63451bf0b1e",
    "ratio": 0.75
  },
  {
    "slug": "sechs-esszimmerstuehle-mit-metallgestell-und-lederbezug",
    "cat": "stuehle",
    "title": "Sechs Esszimmerstühle mit Metallgestell und Lederbezug",
    "alter": "Ca. 15 Jahre alt",
    "zustand": "Polster durchgesessen, Bezug fleckig",
    "aufwand": "Sitz- und Rückenflächen werden mit neuem Schaumstoff aufgepolstert, Bezüge werden aus Leder nach Vorlage angefertigt und montiert.",
    "hours": "25 Stunden",
    "materials": "Schaumstoff in verschiedenen Härtegraden für Sitz und Rücken",
    "cover": "Möbelleder (Rinderleder) in zwei verschiedenen Farben",
    "before": "f97a2353a01bdc6cd0bcff031398ad3f",
    "after": "14587684674fdbbbaffa30680f4f08d0",
    "ratio": 0.75
  },
  {
    "slug": "stuhl-mit-ruecken-und-sitzpolster",
    "cat": "stuehle",
    "title": "Stuhl mit Rücken- und Sitzpolster",
    "alter": "Um 1900",
    "zustand": "Bezug und Polster defekt",
    "aufwand": "Nachdem der Kunde das Gestell lackiert hat, polstern wir Sitz- und Rückenfläche auf und beziehen beide.",
    "hours": "5 Stunden",
    "materials": "Gurte, dünne Schaumstoffe, Vlies",
    "cover": "Mustervelours mit farblich passender Bordüre",
    "after": "490bea614de680094beb9ab4c399138f",
    "ratio": 0.665,
    "antik": true
  },
  {
    "slug": "vier-stuehle-mit-sitzkissen-aus-leder",
    "cat": "stuehle",
    "title": "Vier Stühle mit Sitzkissen aus Leder",
    "alter": "Unbekannt",
    "zustand": "Lack am Holzgestell blättert ab, Unterpolsterung aus Gurten durchgesessen, Sitzkissen nicht mehr vorhanden.",
    "aufwand": "Die Stuhlrahmen schleifen wir ab und lackieren diese mit einem Klarlack auf Wasserbasis. Wir erneuern die Gurtung und fertigen Schaumstoffkissen mit Lederbezügen für die Sitzflächen an.",
    "hours": "17 Stunden",
    "materials": "Holzlack auf Wasserbasis, Synthetikgurte, Schaumstoff",
    "cover": "Weiches, strapazierfähiges Möbelleder (Rinderleder)",
    "before": "c050cefbf96b1869d8e677159a8be502",
    "after": "e86dc6782bf639d6e1d79d4e27d6ce1c",
    "ratio": 0.75
  },
  {
    "slug": "sechs-stuehle-aus-korbgeflecht",
    "cat": "stuehle",
    "title": "Sechs Stühle aus Korbgeflecht",
    "alter": "Unbekannt",
    "zustand": "Sitzflächen durchgesessen, Bezug fleckig",
    "aufwand": "Die alte Polsterung wird ersetzt, die Sitze neu bezogen 7,5 Arbeitsstunden",
    "materials": "Schaumstoff, Kleinmaterial",
    "cover": "Bunter Punkte-Velours",
    "after": "037617a6de6591d48b0f78e91d69a483",
    "ratio": 0.8
  },
  {
    "slug": "zwei-armlehnstuehle-im-chippendale-stil",
    "cat": "stuehle",
    "title": "Zwei Armlehnstühle im Chippendale-Stil",
    "alter": "Unbekannt",
    "zustand": "Stoff und Polsterung defekt",
    "aufwand": "Bezugsstoff und Polsterung der Stühle werden entfernt. Sitz- und Rückenflächen werden mit Gummigurten und Schaumstoffen in verschiedenen Härtegraden aufgepolstert. Die Stühle werden bezogen und mit einem farblich passenden Doppelkeder abgeschlossen.",
    "hours": "17 Stunden",
    "materials": "Gummigurte, Schaumstoffe in verschiedenen Härtegraden, Vliese.",
    "cover": "„Q2“ strapazierfähiger Synthetikstoff mit 5 Jahren Herstellergarantie, farblich passender Doppelkeder.",
    "after": "ca09d4518373516c82ecf0e55c9adeaa",
    "ratio": 0.75
  },
  {
    "slug": "stuhl-im-rokoko-stil",
    "cat": "stuehle",
    "title": "Stuhl im Rokoko-Stil",
    "alter": "Um 1900",
    "zustand": "Polsterung und Bezugsstoff defekt, Holz wurde fleckig nachlackiert",
    "aufwand": "Die nachträglich aufgetragene Farbe wird vom Gestell mit Ablauger abgewaschen und das Holz wird mit Öl eingelassen, nachdem Polsterung und Bezugsstoff entfernt wurden. Rücken- und Sitzfläche werden aufgepolstert und neu bezogen.",
    "hours": "13 Stunden",
    "materials": "Schaumstoffe, Gurte, Abbeizer und Polieröl",
    "cover": "Streifenvelours mit farblich passendem Doppelkeder als Abschluss",
    "after": "608b448d17aaf08655181f37a5013a97",
    "ratio": 0.58,
    "antik": true
  },
  {
    "slug": "traustuehle-der-markuskirche-stuttgart",
    "cat": "stuehle",
    "title": "Traustühle der Markuskirche, Stuttgart",
    "alter": "Unbekannt",
    "zustand": "Polsterungen und Bezüge defekt",
    "aufwand": "Bezugsstoff und Polsterung werden komplett entfernt. Die Stühle werden mit Gurten und Schaumstoffen in verschiedenen Härtegraden aufgepolstert. Sie werden bezogen und mit Gimpenborte sowie Ziernägeln abgeschlossen. 16,5 Arbeitsstunden.",
    "materials": "Gurte, Schaumstoffe, Vliese.",
    "cover": "Velours, Gimpenborte und Ziernägel",
    "after": "2b5bec22c0e26931eeaf3fca612492a2",
    "ratio": 1.1,
    "badge": "Referenz"
  },
  {
    "slug": "zwei-biedermeierstuehle",
    "cat": "stuehle",
    "title": "Zwei Biedermeierstühle",
    "alter": "2.Hälfte d. 19. Jahrhunderts",
    "zustand": "Bezugsstoff ausgebleicht, Polster defekt und ausserdem zu hoch in Relation zu dem Stuhlgestell gepolstert – Proportionen stimmen nicht.",
    "aufwand": "Die Polsterung wird entfernt. Da die Gestelle zu instabil und zierlich sind um eine traditionelle Federschnürung anzubringen, wird ein Federkorb als Unterpolster verwendet. Auf diesem wird mit traditioneller Technik aufgepolstert. Ein Weißpolster wird angefertigt und die Stühle werden bezogen und mit passender Bordüre abgeschlossen. Zusätzlich wird ein Auflagekissen angefertigt, damit der Stuhl wieder als Schreibtischstuhl verwendet werden kann.",
    "hours": "16 Stunden",
    "materials": "Federkörbe, Palmfaser (Afrik), Rosshaar, Nesselstoff und Baumwollwatte",
    "cover": "Polyester-/Viskosesatin",
    "before": "ab0df017c06e75130760576cb343a2a4",
    "after": "ac95f75a7fd4a51fe5eff7bb0679092e",
    "ratio": 0.789,
    "antik": true
  },
  {
    "slug": "armlehnstuhl-teilrestaurierung-schloss-meersburg",
    "cat": "stuehle",
    "title": "Armlehnstuhl Teilrestaurierung (Schloß Meersburg)",
    "alter": "Um 1750",
    "zustand": "Das Rückenpolster und der Bezugsstoff fehlen. Das Sitzpolster ist an der Oberpolsterung beschädigt. Fehlende und beschädigte Holzteile werden vom Holzrestaurator ersetzt. Die Lackierung und Vergoldungen werden ebenfalls restauriert.",
    "aufwand": "Die vorhandene Sitzpolsterung wird erhalten und mit Baumwollwatte und einem neuen Nesselbezug abgedeckt. Genauso wird mit den Armlehnen verfahren. Ein Rückenpolster wird aus Rosshaar mittels historischer Technik angefertigt. Der Armlehnstuhl wird bezogen und mit einer Bordüre abgeschlossen.",
    "hours": "15 Stunden",
    "materials": "Rosshaar, Baumwollwatte, Baumwollnessel, Leinwand aus Jute",
    "cover": "Seidendamast nach historischer Vorlage gewebt (Sonderanfertigung), Abschluss mit passender Bordüre",
    "before": "9616b2b44ab64b5f8c87df386ce2f4af",
    "after": "b68a8b2253541feb0ff290ab832680fb",
    "ratio": 0.75,
    "antik": true,
    "badge": "Referenz"
  },
  {
    "slug": "sechs-stuehle-spaetes-19-jahrhundert",
    "cat": "stuehle",
    "title": "Sechs Stühle spätes 19. Jahrhundert",
    "alter": "Um 1880",
    "zustand": "Polsterung durchgesessen, Stoff nicht mehr schön",
    "aufwand": "Stoff und Polsterung werden entfernt. Sitze werden mit Federkörben und Schaumstoff aufgepolstert, bezogen und mit Doppelkeder abgeschlossen.",
    "hours": "22 Stunden",
    "materials": "Federkörbe, Schaumstoff, Vlies",
    "cover": "Streifenvelours aus Viskose/Polyester",
    "before": "1b6190558908ce2e3c8702421561ac40",
    "after": "f9c513bb9092757355adbab20c030c98",
    "ratio": 0.665,
    "antik": true
  },
  {
    "slug": "holzarmlehnstuhl",
    "cat": "stuehle",
    "title": "Holzarmlehnstuhl",
    "alter": "Anfang 20. Jahrhundert",
    "zustand": "Bezugsstoff und Polsterung defekt, Rückenlehne des Holzgestells gebrochen",
    "aufwand": "Die Polsterung wird entfernt damit die gebrochene Rückenlehne vom Schreiner fachgerecht repariert werden kann. Der Stuhl wird aufgepolstert und bezogen, das Rückenpolster mit Ziernägeln abgeschlossen. Kleine Schäden am Holzgestell werden nachgebessert/-gebeizt.",
    "hours": "5 Stunden",
    "materials": "Gurte, Schaumstoffe",
    "before": "e50d419f00b5a0f1f3e8c031c6c8730f",
    "after": "f01b44a3769fd65c92bf5815c9061480",
    "ratio": 0.76,
    "antik": true
  },
  {
    "slug": "60er-jahre-stuhl",
    "cat": "stuehle",
    "title": "60er Jahre Stuhl",
    "alter": "Um 1960",
    "zustand": "Polster und Bezugsstoff defekt, Gestell aus dem Leim.",
    "aufwand": "Stoff und Polster werden entfernt und das Gestell wird verleimt. Der Stuhl wird aufgepolstert und neu bezogen.",
    "hours": "6 Stunden",
    "materials": "Federkorb (für Sitzpolster), Schaumstoffe",
    "cover": "Leinen-/Viskosegewebe",
    "after": "f71919faa66458925356a8b0c689569f",
    "ratio": 0.75
  },
  {
    "slug": "betstuhl",
    "cat": "stuehle",
    "title": "Betstuhl / Kniehocker",
    "alter": "Um 1900",
    "zustand": "Polster und Bezugsstoff defekt, Gestell wackelt.",
    "aufwand": "Stoff und Polster werden entfernt. Das Holzgestell wird verleimt. Der Stuhl wird aufgepolstert, bezogen und mit farblich passender Bordüre sowie Ziernägeln abgeschlossen. 7,5 Arbeitsstunden",
    "materials": "Federkorb, Schaumstoffe",
    "cover": "Baumwoll-/Viskosesatin mit Rautenmuster",
    "after": "6a6465801b3c2b7095d8b6dff944cee2",
    "ratio": 0.665,
    "antik": true
  },
  {
    "slug": "thonet-stuhl",
    "cat": "stuehle",
    "title": "Thonet Stuhl",
    "alter": "Unbekannt",
    "zustand": "Stuhl gefällt nicht mehr",
    "aufwand": "Nachdem der Kunde den dunklen Lack vom Holzgestell geschliffen hat, polstern wir die Sitz- und Rückenfläche neu auf und beziehen diese.",
    "hours": "4 Stunden",
    "materials": "Schaumstoffe für Sitz und Rücken",
    "cover": "Bunter Mustervelours",
    "after": "368e4d0a2be268193935283f27bc5cbd",
    "ratio": 0.75
  },
  {
    "slug": "3-stuehle-mit-geschnitzten-rahmen-und-holzarmlehnen",
    "cat": "stuehle",
    "title": "3 Stühle mit geschnitzten Rahmen und Holzarmlehnen",
    "alter": "Spätes 19. Jahrhundert",
    "zustand": "Bei den beiden kleinen Stühlen ist die Polsterung leider komplett defekt, die traditionelle Sitzpolsterung des Armlehnstuhls kann zum größten Teil erhalten werden. Bezugsstoffe sind verschlissen.",
    "aufwand": "Bezugsstoffe sowie die komplette Polsterung der kleinen Stühle werden entfernt. Beim Armlehnstuhl wird nur die Oberpolsterung erneuert und der Sitz wird mit einem neuen Weißpolster aus Nesselstoff versehen. Die kleinen Stühle werden mit Federkörben im Sitz und neuen Schaumstoffen aufgepolstert. Alle Stühle werden bezogen und mit passendem Doppelkeder abgeschlossen.",
    "hours": "22 Stunden",
    "materials": "Federkörbe, Schaumstoffe in verschiedenen Härtegraden",
    "cover": "Mustervelours und passender Doppelkeder",
    "before": "4d9b35156820bd9778ebf892c3215a00",
    "after": "7eef58a68bd2be3b356addf36b391ecf",
    "ratio": 0.794,
    "antik": true
  },
  {
    "slug": "2-stuehle-schwarz-lackiert",
    "cat": "stuehle",
    "title": "2 Stühle schwarz lackiert",
    "alter": "Um 1900",
    "zustand": "Polsterung und Bezug komplett kaputt",
    "aufwand": "Da Rücken und Sitz ursprünglich mit einem Geflecht versehen waren, geben die Zargen wenig halt für Gurte oder Federkern. Deshalb wird eine Holzplatte im Sitz sowie im Rücken eingesetzt. Auf diese Platten wird mit Schaumstoff relativ dünn aufgepolstert, damit das Polster nicht zu sehr aufträgt und „bauchig“ wirkt. Sitz- und Rückenflächen werden bezogen und mit Ziernägeln in Blütenform abgeschlossen. 5,5 Arbeitsstunden",
    "materials": "Dünne Multiplex Holzplatte, Schaumstoff",
    "cover": "Velours aus Mischfasern",
    "after": "df9008ccf287b27289d66b969cefb112",
    "ratio": 1.02,
    "antik": true
  },
  {
    "slug": "louis-philippe-stuhl",
    "cat": "stuehle",
    "title": "Louis-Philippe Stuhl",
    "alter": "Unbekannt",
    "zustand": "Polsterung und Bezug verschlissen.",
    "aufwand": "Bezug und Polsterung werden entfernt. Der Stuhlsitz wird aufgepolstert, neu bezogen und mit passendem Doppelkeder abgeschlossen. 5,5 Arbeitsstunden",
    "materials": "Federkorb, Schaumstoff",
    "cover": "Streifenvelours",
    "after": "ebfe7a1e76b71289949af863d98abd62",
    "ratio": 0.75
  },
  {
    "slug": "vier-bunte-stuehle-mit-holzarmlehnen",
    "cat": "stuehle",
    "title": "Vier bunte Stühle mit Holzarmlehnen",
    "alter": "Ca. 50 Jahre",
    "zustand": "Polsterung und Bezug defekt",
    "aufwand": "Nach dem Entfernen von Bezug und Polsterung werden die Stühle aufgepolstert und neu bezogen.",
    "hours": "20 Stunden",
    "materials": "Federkörbe als Sitzunterpolsterung, Schaumstoffe in verschiedenen Härtegraden in Sitz und Rücken",
    "cover": "Synthetik Webstoff mit Fleckschutz in vier verschiedenen Farben und den jeweils farblich passenden Doppelkeder als Abschluss.",
    "after": "b4273885277714dfba6f244d5691fdf2",
    "ratio": 1.333
  }
];

export const categories: { slug: Category; label: string; swatch: string; heading: string }[] = [
  { slug: "sofas", label: "Sofas", swatch: "#1F5E66", heading: "Sofas" },
  { slug: "liegen-baenke", label: "Liegen & Bänke", swatch: "#7A3E4E", heading: "Liegen und Bänke" },
  { slug: "sessel", label: "Sessel", swatch: "#8C5A2B", heading: "Sessel" },
  { slug: "stuehle", label: "Stühle", swatch: "#6B7340", heading: "Stühle" },
];

export const antikSwatch = "#9A7B3F";

// Shown above the gallery when a category filter is active (from ideensprung.de).
export const intros: Record<Category, { title: string; p1: string; p2: string }> = {
  sofas: {
    title: "Sofa – modern oder Rokoko, Biedermeier & Co.",
    p1: "Ob Omas Lieblings-Sofa mit Ohrenbacken, Ihr modernes Sofa oder Ihr gutes Stil-Sofa. Wählen Sie aus vielen Stoffmustern die passende Farbe und Muster und fühlen Sie den Stoff anhand unserer Muster-Kollektionen.",
    p2: "So erhalten Sie nicht nur wieder ein neues Sitzgefühl. Ihr Sofa gibt Ihrem Wohnzimmer wieder eine völlig neue Ausstrahlung.",
  },
  "liegen-baenke": {
    title: "Liegen – wie neu geboren!",
    p1: "Auf Ihrer Chaiselongue, Ihrer Recamiere, Ihrer Biedermeier-Bank oder Ihrer Schlafcouch. Eine neue Polsterung bewirkt Wunder für Ihren Rücken und Ihr Wohlbefinden. Wählen Sie aus vielen Stoffmustern die richtige Farbe und ein passendes Muster – denn Sie sollen rundum angenehm neu liegen.",
    p2: "Machen Sie den Test: Kommen Sie vorbei und sehen und befühlen Sie unsere Stoffmuster! Bitte mit Voranmeldung, damit wir auch für Sie da sein können.",
  },
  sessel: {
    title: "Sessel in allen Variationen",
    p1: "Voltairesessel, Club-Sessel, Designer-Sessel, Empire-Sessel, Ohrensessel, Cocktail-Sessel … Wir möbeln Ihren abgenutzten, durchgesessenen Sessel wieder auf und geben ihm mit einem wunderschönen Stoff ein nagelneues Outfit. So wird Ihre Einrichtung wieder um ein hübsches Möbel reicher.",
    p2: "Auch passende Kissen, Hocker oder verstellbare Lehnen können mit meisterlicher Handwerkskunst überarbeitet werden – mit gutem Preis-Leistungs-Verhältnis. Testen Sie uns einfach!",
  },
  stuehle: {
    title: "Sitzen Sie bequem?",
    p1: "Da wir in unserer heutigen Zeit viel sitzen, ist die Qualität unserer Stühle immens wichtig geworden. Mit einer neuen Polsterung in echter Handwerkskunst werden Sie den Unterschied deutlich fühlen. Ihr Rücken und Ihr ganzes Wohlbefinden werden es Ihnen danken.",
    p2: "Strapazierfähige Stoffe mit hoher Langlebigkeit stehen Ihnen in vielen Designs zur Auswahl – immer passend zur jeweiligen Art Ihres Stuhles. Gerne beraten wir Sie genau für Ihren Bedarf.",
  },
};

// Gallery filters; each is its own route (/polsterei/ and /polsterei/<key>/).
export type Filter = "alle" | Category | "antik";

export function inFilter(f: Filter): Project[] {
  if (f === "alle") return projects;
  if (f === "antik") return projects.filter((p) => p.antik);
  return projects.filter((p) => p.cat === f);
}

export function filterHeading(f: Filter): string {
  if (f === "alle") return "Polsterarbeiten";
  if (f === "antik") return "Antike Stücke";
  return categories.find((c) => c.slug === f)!.heading;
}

export function categoryOf(p: Project) {
  return categories.find((c) => c.slug === p.cat)!;
}

export function projectBySlug(slug: string): Project | undefined {
  return projects.find((p) => p.slug === slug);
}

export const filters: Filter[] = ["alle", "sofas", "liegen-baenke", "sessel", "stuehle", "antik"];

export function isFilter(s: string): s is Filter {
  return (filters as string[]).includes(s);
}

export function filterPath(f: Filter): string {
  return f === "alle" ? "/polsterei/" : `/polsterei/${f}/`;
}

export function filterLabel(f: Filter): string {
  if (f === "alle") return "Alle";
  if (f === "antik") return "Antik & Restaurierung";
  return categories.find((c) => c.slug === f)!.label;
}

export function filterSwatch(f: Filter): string | undefined {
  if (f === "alle") return undefined;
  if (f === "antik") return antikSwatch;
  return categories.find((c) => c.slug === f)!.swatch;
}

// h1 of the gallery and of each filter route, e.g. "Sofas aus unserer Werkstatt."
// h1 of a filter route: a category's heading from ideensprung.de, written in the voice of its intro text
// ("Sitzen Sie bequem?"); Alle and Antik, whose text says "we", get their own ("Meisterliche Polsterarbeiten").
export function filterHeadline(f: Filter): string {
  return f === "alle" || f === "antik" ? filterTitle(f) : intros[f].title;
}

// page title of a filter route: "Meisterliche Polsterarbeiten", "Unsere Sofas" …
export function filterTitle(f: Filter): string {
  if (f === "alle") return "Meisterliche Polsterarbeiten";
  if (f === "antik") return "Unsere Restaurierungen";
  return `Unsere ${filterHeading(f)}`;
}

export function filterDescription(f: Filter): string {
  const n = inFilter(f).length;
  if (f === "alle") return `${n} Polsterarbeiten aus unserer Werkstatt in Filderstadt: Sofas, Liegen, Bänke, Sessel und Stühle, modern neu bezogen oder traditionell restauriert.`;
  if (f === "antik") return `${n} antike Stücke und Restaurierungen aus unserer Polsterei in Filderstadt, traditionell gepolstert mit Federn, Palmfaser und Rosshaar.`;
  return `${filterHeading(f)} aus unserer Polsterei in Filderstadt: ${n} Arbeiten mit Vorher-Nachher-Fotos. ${intros[f].title}`;
}

// Traditional upholstery (hand-tied springs, palm fibre, horsehair) according to the project's text.
export function isTraditional(p: Project): boolean {
  return /traditionell|Rosshaar|Taillenfeder|handgeschnürt|geschnürt/i.test(p.aufwand ?? "");
}
